import { Brain, Users, Target, TrendingUp } from "lucide-react";


const principles = [
  {
    icon: Brain,
    title: "Social Facilitation",
    stat: "Proven by research",
    description: "The mere presence of others improves task performance. Psychologists call this social facilitation — you naturally work harder when someone is watching.",
  },
  {
    icon: Users,
    title: "Body Doubling",
    stat: "Used by ADHD coaches",
    description: "Working alongside another person — even silently — anchors your attention. Originally an ADHD strategy, it works for everyone who struggles to start or stay focused.",
  },
  {
    icon: Target,
    title: "Accountability Effect",
    stat: "65% → 95%",
    description: "Committing a goal to someone else raises follow-through from 25% to 65%. A scheduled accountability session pushes it to 95%.",
  },
  {
    icon: TrendingUp,
    title: "Peer Motivation",
    stat: "30% better outcomes",
    description: "Students who engage in study sessions with peers are 30% more likely to succeed compared to those who study alone.",
  },
];

export const BodyDoubling = () => {
  return (
    <section className="py-24 relative overflow-hidden" aria-labelledby="body-doubling-title">
      <div className="absolute inset-0 bg-gradient-to-b from-muted/50 via-background to-muted/50" aria-hidden="true" />
      <div className="absolute bottom-1/4 left-1/4 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[120px]" aria-hidden="true" />

      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <header className="text-center mb-16 animate-fade-in">
            <h2 id="body-doubling-title" className="font-display text-4xl sm:text-5xl font-bold mb-6">
              <span className="text-gradient">Body Doubling:</span>{" "}
              <span className="text-foreground">The Science Behind It</span>
            </h2>
            <p className="text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed">
              CSW is built on proven psychological principles. Here's why studying alongside others — even strangers on a screen — dramatically improves your focus and output.
            </p>
          </header>




          <div className="grid sm:grid-cols-2 gap-6">
            {principles.map((principle, index) => {
              const Icon = principle.icon;
              return (
                <article
                  key={principle.title}
                  className="group p-8 rounded-2xl bg-card/50 backdrop-blur-sm border border-border/50 hover:border-primary/30 hover:bg-card/80 transition-all duration-300 animate-fade-in"
                  style={{ animationDelay: `${0.1 + index * 0.1}s` }}
                >
                  <div className="flex items-start gap-4">
                    <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-primary/20 to-secondary/20 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                      <Icon className="w-7 h-7 text-primary" aria-hidden="true" />
                    </div>
                    <div>
                      <p className="text-xs font-bold text-primary uppercase tracking-wider mb-1">{principle.stat}</p>
                      <h3 className="text-xl font-bold text-foreground mb-2">{principle.title}</h3>
                      <p className="text-muted-foreground leading-relaxed">{principle.description}</p>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};